import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Analytics from 'react-router-ga';
import Navbar from './components/navbar/Navbar'
import Dashboard from './components/maps/Dashboard'
import MapDetails from './components/maps/MapDetails'
import SignIn from './components/auth/SignIn'
import CreateMap from './components/maps/CreateMap'
import Profile from './components/profile/Profile'

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Analytics id="UA-66796502-3">
        <div className="App">
          <Route path='/' component={Navbar}/>
          <Switch>
            <Route exact path='/' component={Dashboard} />
            <Route path='/map/:id' component={MapDetails} />
            <Route path='/signin' component={SignIn} />
            <Route path='/create' component={CreateMap} />
            <Route path='/profile' component={Profile} />
          </Switch>
        </div>
        </Analytics>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js